import * as React from "react";
import "./AddStorageDriver.less";
import {injectIntl, InjectedIntlProps, FormattedMessage} from "react-intl";
import {Form, message, Select, Input, Button, Tooltip} from "antd";
import {push} from "@netless/i18n-react-router";
import {RouteComponentProps, withRouter} from "react-router";
import {MenuSliderEnum} from "../MenuSlider";
import {driverStore} from "../../../models/DriverStore";
import NavGoBack from "../NavGoBack";
import {ServiceTypeEnum} from "../serviceCenter/ProjectDetail";
import {FormInstance} from "antd/lib/form";
import { Lan } from "../../../locale";
import { getRegionName, region } from "../../../apiMiddleware/region";

const FormItem = Form.Item;
const Option = Select.Option;
export enum StorageType {
    netless = "netless",
    aliyun = "aliyun",
    qiniu = "qiniu",
    aws = "aws",
}
export type AddDriverProps = InjectedIntlProps & RouteComponentProps<{provider: StorageType, storageId?: string}>;

export type AddDriverStates = {
};
class AddStorageDriver extends React.Component<AddDriverProps, AddDriverStates> {
    private readonly formRef: React.RefObject<FormInstance> = React.createRef();
    public constructor(props: AddDriverProps) {
        super(props);
    }

    public async componentDidMount(): Promise<void> {
        const {storageId, provider} = this.props.match.params;
        if (storageId && storageId !== "0") {
            const driverId = parseInt(storageId);
            try {
                await driverStore.getStorageDriversById(driverId);
                if (driverStore.currentStorageDriver) {
                    if (provider === StorageType.aliyun) {
                        this.formRef.current!.setFieldsValue({
                            ali_cloud_storage_ak: driverStore.currentStorageDriver.ak,
                            ali_cloud_storage_sk: driverStore.currentStorageDriver.sk,
                            ali_cloud_storage_zone: driverStore.currentStorageDriver.region,
                            ali_cloud_storage_bucket: driverStore.currentStorageDriver.bucket,
                            ali_cloud_storage_path: driverStore.currentStorageDriver.path,
                            ali_cloud_storage_domain: driverStore.currentStorageDriver.domain,
                        });
                    } else if (provider === StorageType.aws) {
                        this.formRef.current!.setFieldsValue({
                            aws_cloud_storage_ak: driverStore.currentStorageDriver.ak,
                            aws_cloud_storage_sk: driverStore.currentStorageDriver.sk,
                            aws_cloud_storage_zone: driverStore.currentStorageDriver.region,
                            aws_cloud_storage_bucket: driverStore.currentStorageDriver.bucket,
                            aws_cloud_storage_path: driverStore.currentStorageDriver.path,
                            aws_cloud_storage_domain: driverStore.currentStorageDriver.domain,
                        });
                    } else {
                        this.formRef.current!.setFieldsValue({
                            qiniu_cloud_storage_ak: driverStore.currentStorageDriver.ak,
                            qiniu_cloud_storage_sk: driverStore.currentStorageDriver.sk,
                            qiniu_cloud_storage_zone: driverStore.currentStorageDriver.region,
                            qiniu_cloud_storage_bucket: driverStore.currentStorageDriver.bucket,
                            qiniu_cloud_storage_path: driverStore.currentStorageDriver.path,
                            qiniu_cloud_storage_domain: driverStore.currentStorageDriver.domain,
                        });
                    }
                }
            } catch (err) {
                message.error(err.message);
            }
        }
    }
    private getActiveSelectedKey = (): MenuSliderEnum => {
        let str = location.pathname;
        const regex = /([^\/]+)/gm;
        regex.exec(str);
        const arr2 = regex.exec(str);
        if (arr2 === null) {
            str = "";
        } else {
            str = arr2[0];
        }
        switch (str) {
            case "management":
                return MenuSliderEnum.management;
            case "finance":
                return MenuSliderEnum.finance;
            case "user-center":
                return MenuSliderEnum.user_center;
            case "debug":
                return MenuSliderEnum.debug;
            default:
                return MenuSliderEnum.dashboard;
        }
    }

    private getActiveSelectedKey2 = (): ServiceTypeEnum => {
        let str = location.pathname;
        const regex = /([^\/]+)/gm;
        regex.exec(str);
        regex.exec(str);
        const arr2 = regex.exec(str);
        if (arr2 === null) {
            str = "";
        } else {
            str = arr2[0];
        }
        return str as ServiceTypeEnum;
    }

    private handleSubmitStorage = async (values: any): Promise<void> => {
        const {provider, storageId} = this.props.match.params;
        if (this.getActiveSelectedKey() === MenuSliderEnum.user_center) {
            if (provider === StorageType.aliyun) {
                if (storageId) {
                    await this.updateStorageAliyunDriver(values, parseInt(storageId));
                } else {
                    await this.submitStorageAliyunDriver(values);
                }
            } else if (provider === StorageType.aws) {
                if (storageId) {
                    await this.updateStorageAwsDriver(values, parseInt(storageId));
                } else {
                    await this.submitStorageAwsDriver(values);
                }
            } else {
                if (storageId) {
                    await this.updateStorageQiniuDriver(values, parseInt(storageId));
                } else {
                    await this.submitStorageQiniuDriver(values);
                }
            }
            push(this.props.history, `/${this.getActiveSelectedKey()}/driver/`);
        } else {
            if (provider === StorageType.aliyun) {
                if (storageId) {
                    await this.updateStorageAliyunDriver(values, parseInt(storageId));
                    await driverStore.updateDriveInService({
                        type: this.getActiveSelectedKey2(),
                        configuration: {
                            storageDriverId: parseInt(storageId),
                        },
                    });
                } else {
                    await this.submitStorageAndUpdateAliyunDriver(values);
                }
            } else if (provider === StorageType.aws) {
                if (storageId) {
                    await this.updateStorageAwsDriver(values, parseInt(storageId));
                    await driverStore.updateDriveInService({
                        type: this.getActiveSelectedKey2(),
                        configuration: {
                            storageDriverId: parseInt(storageId),
                        },
                    });
                } else {
                    await this.submitStorageAndUpdateAwsDriver(values);
                }
            } else {
                if (storageId) {
                    await this.updateStorageQiniuDriver(values, parseInt(storageId));
                    await driverStore.updateDriveInService({
                        type: this.getActiveSelectedKey2(),
                        configuration: {
                            storageDriverId: parseInt(storageId),
                        },
                    });
                } else {
                    await this.submitStorageAndUpdateQiniuDriver(values);
                }
            }
            push(this.props.history, `/${this.getActiveSelectedKey()}/${this.getActiveSelectedKey2()}/driver-set/`);
        }
    }

    private deleteDriver = async (storageId: number): Promise<void> => {
        await driverStore.deleteStorageDriver(storageId);
        if (this.getActiveSelectedKey() === MenuSliderEnum.user_center) {
            push(this.props.history, `/${this.getActiveSelectedKey()}/driver/`);
        } else {
            push(this.props.history, `/${this.getActiveSelectedKey()}/${this.getActiveSelectedKey2()}/driver-set/`);
        }
    }

    private updateStorageAliyunDriver = async (values: any, storageId: number): Promise<void> => {
        const {provider} = this.props.match.params;
        await driverStore.upDateStorageDriver({
            ak: values.ali_cloud_storage_ak,
            sk: values.ali_cloud_storage_sk,
            bucket: values.ali_cloud_storage_bucket,
            region: values.ali_cloud_storage_zone,
            path: values.ali_cloud_storage_path,
            domain: values.ali_cloud_storage_domain,
            provider: provider}, storageId);
    }

    private updateStorageAwsDriver = async (values: any, storageId: number): Promise<void> => {
        const {provider} = this.props.match.params;
        await driverStore.upDateStorageDriver({
            ak: values.aws_cloud_storage_ak,
            sk: values.aws_cloud_storage_sk,
            bucket: values.aws_cloud_storage_bucket,
            region: values.aws_cloud_storage_zone,
            path: values.aws_cloud_storage_path,
            domain: values.aws_cloud_storage_domain,
            provider: provider}, storageId);
    }

    private updateStorageQiniuDriver = async (values: any, storageId: number): Promise<void> => {
        const {provider} = this.props.match.params;
        await driverStore.upDateStorageDriver({
            ak: values.qiniu_cloud_storage_ak,
            sk: values.qiniu_cloud_storage_sk,
            bucket: values.qiniu_cloud_storage_bucket,
            region: values.qiniu_cloud_storage_zone,
            path: values.qiniu_cloud_storage_path,
            domain: values.qiniu_cloud_storage_domain,
            provider: provider}, storageId);
    }

    private submitStorageAliyunDriver = async (values: any): Promise<void> => {
        const {provider} = this.props.match.params;
        await driverStore.submitStorageDriver({
            ak: values.ali_cloud_storage_ak,
            sk: values.ali_cloud_storage_sk,
            bucket: values.ali_cloud_storage_bucket,
            region: values.ali_cloud_storage_zone,
            path: values.ali_cloud_storage_path,
            domain: values.ali_cloud_storage_domain,
            provider: provider});
    }

    private submitStorageAndUpdateAliyunDriver = async (values: any): Promise<void> => {
        const {provider} = this.props.match.params;
        await driverStore.submitAndUpdateStorageDriver({
            ak: values.ali_cloud_storage_ak,
            sk: values.ali_cloud_storage_sk,
            bucket: values.ali_cloud_storage_bucket,
            region: values.ali_cloud_storage_zone,
            path: values.ali_cloud_storage_path,
            domain: values.ali_cloud_storage_domain,
            provider: provider}, this.getActiveSelectedKey2());
    }

    private submitStorageAwsDriver = async (values: any): Promise<void> => {
        const {provider} = this.props.match.params;
        await driverStore.submitStorageDriver({
            ak: values.aws_cloud_storage_ak,
            sk: values.aws_cloud_storage_sk,
            bucket: values.aws_cloud_storage_bucket,
            region: values.aws_cloud_storage_zone,
            path: values.aws_cloud_storage_path,
            domain: values.aws_cloud_storage_domain,
            provider: provider});
    }

    private submitStorageAndUpdateAwsDriver = async (values: any): Promise<void> => {
        const {provider} = this.props.match.params;
        await driverStore.submitAndUpdateStorageDriver({
            ak: values.aws_cloud_storage_ak,
            sk: values.aws_cloud_storage_sk,
            bucket: values.aws_cloud_storage_bucket,
            region: values.aws_cloud_storage_zone,
            path: values.aws_cloud_storage_path,
            domain: values.aws_cloud_storage_domain,
            provider: provider}, this.getActiveSelectedKey2());
    }


    private submitStorageQiniuDriver = async (values: any): Promise<void> => {
        const {provider} = this.props.match.params;
        await driverStore.submitStorageDriver({
            ak: values.qiniu_cloud_storage_ak,
            sk: values.qiniu_cloud_storage_sk,
            bucket: values.qiniu_cloud_storage_bucket,
            region: values.qiniu_cloud_storage_zone,
            path: values.qiniu_cloud_storage_path,
            domain: values.qiniu_cloud_storage_domain,
            provider: provider});
    }

    private submitStorageAndUpdateQiniuDriver = async (values: any): Promise<void> => {
        const {provider} = this.props.match.params;
        await driverStore.submitAndUpdateStorageDriver({
            ak: values.qiniu_cloud_storage_ak,
            sk: values.qiniu_cloud_storage_sk,
            bucket: values.qiniu_cloud_storage_bucket,
            region: values.qiniu_cloud_storage_zone,
            path: values.qiniu_cloud_storage_path,
            domain: values.qiniu_cloud_storage_domain,
            provider: provider}, this.getActiveSelectedKey2());
    }

    private renderStorageByProvide = (): React.ReactNode  => {
        const {intl, match} = this.props;
        const {provider, storageId} = match.params;
        switch (provider) {
            case StorageType.aliyun: {
                return [
                    <div className="set-box-title" key={"title"}>
                        <FormattedMessage
                            id={"driver.configure-ali-storage"}
                        />
                    </div>,
                    <Form ref={this.formRef} key={"form"} onFinish={this.handleSubmitStorage} className="login-form">
                        <FormItem
                            name={"ali_cloud_storage_ak"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-oss-ak"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-oss-ak"})}/>
                        </FormItem>
                        <FormItem
                            name={"ali_cloud_storage_sk"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-oss-sk"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-oss-sk"})}/>
                        </FormItem>
                        <FormItem
                            name={"ali_cloud_storage_zone"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-oss-region"})}]}
                            initialValue={"oss-cn-hangzhou"}
                        >
                            <Select className="select-box-inner">
                                <Option value="oss-cn-hangzhou">oss-cn-hangzhou</Option>
                                <Option value="oss-cn-shanghai">oss-cn-shanghai</Option>
                                <Option value="oss-cn-qingdao">oss-cn-qingdao</Option>
                                <Option value="oss-cn-beijing">oss-cn-beijing</Option>
                                <Option value="oss-cn-zhangjiakou">oss-cn-zhangjiakou</Option>
                                <Option value="oss-cn-huhehaote">oss-cn-huhehaote</Option>
                                <Option value="oss-cn-shenzhen">oss-cn-shenzhen</Option>
                                <Option value="oss-cn-chengdu">oss-cn-chengdu</Option>
                                <Option value="oss-cn-hongkong">oss-cn-hongkong</Option>
                                <Option value="oss-us-west-1">oss-us-west-1</Option>
                                <Option value="oss-us-east-1">oss-us-east-1</Option>
                                <Option value="oss-ap-southeast-1">oss-ap-southeast-1</Option>
                                <Option value="oss-ap-southeast-2">oss-ap-southeast-2</Option>
                                <Option value="oss-ap-southeast-3">oss-ap-southeast-3</Option>
                                <Option value="oss-ap-southeast-5">oss-ap-southeast-5</Option>
                                <Option value="oss-ap-northeast-1">oss-ap-northeast-1</Option>
                                <Option value="oss-ap-south-1">oss-ap-south-1</Option>
                                <Option value="oss-eu-central-1">oss-eu-central-1</Option>
                                <Option value="oss-eu-west-1">oss-eu-west-1</Option>
                                <Option value="oss-me-east-1">oss-me-east-1</Option>
                            </Select>
                        </FormItem>
                        <FormItem
                            name={"ali_cloud_storage_bucket"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-oss-bucket"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-oss-bucket"})}/>
                        </FormItem>
                        <FormItem
                            name={"ali_cloud_storage_path"}
                            rules={[{required: false, message: intl.formatMessage({id: "driver.input-oss-path"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-oss-path"})}/>
                        </FormItem>
                        <Tooltip title="请确保填入的域名可用，该域名会影响使用了当前存储的服务" placement="right">
                            <FormItem
                                name={"ali_cloud_storage_domain"}
                                rules={[{
                                    required: false,
                                    validator: (rule, value: string, callback) => {
                                        if (value) {
                                            // 自定义域名要以 https 或 http 开头
                                            if (value.indexOf("http://") === 0 || value.indexOf("https://") === 0) {
                                                return callback();
                                            } else {
                                                return callback("域名必须以 'http://' 或 'https://' 开头");
                                            }
                                        } else {
                                            // 可以为空
                                            return callback();
                                        }
                                    },
                                }]}
                            >
                                <Input size={"large"}
                                       placeholder={intl.formatMessage({id: "driver.input-oss-url"})}/>
                            </FormItem>
                        </Tooltip>
                        <FormItem>
                            <Button
                                size="large"
                                type="primary"
                                htmlType="submit"
                                className="token-button">
                                {storageId ? <FormattedMessage id={"driver.update-service"}/> :
                                 <FormattedMessage id={"driver.start-service"}/>}
                            </Button>
                        </FormItem>
                        {storageId &&
                        <Button
                            size="large"
                            onClick={async () => {
                                await this.deleteDriver(parseInt(storageId));
                            }}
                            className="token-button">
                            <FormattedMessage
                                id={"driver.delete-service"}
                            />
                        </Button>}
                    </Form>,
                ];
            }
            case StorageType.aws: {
                return [
                    <div className="set-box-title" key={"title"}>
                        <FormattedMessage
                            id={"driver.configure-aws-storage"}
                        />
                    </div>,
                    <Form key={"sdd"} ref={this.formRef} onFinish={this.handleSubmitStorage} className="login-form">
                        <FormItem
                            name={"aws_cloud_storage_ak"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-aws-ak"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-aws-ak"})}/>
                        </FormItem>
                        <FormItem
                            name={"aws_cloud_storage_sk"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-aws-sk"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-aws-sk"})}/>
                        </FormItem>
                        <FormItem
                            name={"aws_cloud_storage_zone"}
                            initialValue={"cn-north-1"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-aws-region"})}]}
                        >
                            <Select className="select-box-inner">
                                <Option value="cn-north-1">cn-north-1</Option>
                                <Option value="cn-northwest-1">cn-northwest-1</Option>
                            </Select>
                        </FormItem>
                        <FormItem
                            name={"aws_cloud_storage_bucket"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-aws-bucket"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-aws-bucket"})}/>
                        </FormItem>
                        <FormItem
                            name={"aws_cloud_storage_path"}
                            rules={[{required: false, message: intl.formatMessage({id: "driver.input-aws-path"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-aws-path"})}/>
                        </FormItem>
                        <FormItem
                            name={"aws_cloud_storage_domain"}
                            rules={[{required: false, message: intl.formatMessage({id: "driver.input-aws-url"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-aws-url"})}/>
                        </FormItem>
                        <FormItem>
                            <Button
                                size="large"
                                type="primary"
                                htmlType="submit"
                                className="token-button">
                                {storageId ?
                                <FormattedMessage id={"driver.update-service"}/> :
                                <FormattedMessage id={"driver.start-service"}/>
                                }
                            </Button>
                        </FormItem>
                        {storageId &&
                            <Button
                                size="large"
                                onClick={async () => {
                                    await this.deleteDriver(parseInt(storageId));
                                }}
                                className="token-button">
                                <FormattedMessage
                                    id={"driver.delete-service"}
                                />
                            </Button>}
                    </Form>,
                ];
            }
            case StorageType.qiniu: {
                return [
                    <div className="set-box-title" key={"title"}>
                        <FormattedMessage
                            id={"driver.configure-qiniu-storage"}
                        />
                    </div>,
                    <Form key={"sdd"} ref={this.formRef} onFinish={this.handleSubmitStorage} className="login-form">
                        <FormItem
                            name={"qiniu_cloud_storage_ak"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-qiniu-ak"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-qiniu-ak"})}/>
                        </FormItem>
                        <FormItem
                            name={"qiniu_cloud_storage_sk"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-qiniu-sk"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-qiniu-sk"})}/>
                        </FormItem>
                        <FormItem
                            name={"qiniu_cloud_storage_zone"}
                            initialValue={"华东"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-qiniu-region"})}]}
                        >
                            <Select className="select-box-inner">
                                <Option value="华东">华东</Option>
                                <Option value="华北">华北</Option>
                                <Option value="华南">华南</Option>
                                <Option value="北美">北美</Option>
                            </Select>
                        </FormItem>
                        <FormItem
                            name={"qiniu_cloud_storage_bucket"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-qiniu-bucket"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-qiniu-bucket"})}/>
                        </FormItem>
                        <FormItem
                            name={"qiniu_cloud_storage_path"}
                            rules={[{required: false, message: intl.formatMessage({id: "driver.input-qiniu-path"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-qiniu-path"})}/>
                        </FormItem>
                        <FormItem
                            name={"qiniu_cloud_storage_domain"}
                            rules={[{required: true, message: intl.formatMessage({id: "driver.input-qiniu-url"})}]}
                        >
                            <Input size={"large"}
                                   placeholder={intl.formatMessage({id: "driver.input-qiniu-url"})}/>
                        </FormItem>
                        <FormItem>
                            <Button
                                size="large"
                                type="primary"
                                htmlType="submit"
                                className="token-button">
                                {storageId ?
                                <FormattedMessage id={"driver.update-service"}/> :
                                <FormattedMessage id={"driver.start-service"}/>
                                }
                            </Button>
                        </FormItem>
                        {storageId &&
                            <Button
                                size="large"
                                onClick={async () => {
                                    await this.deleteDriver(parseInt(storageId));
                                }}
                                className="token-button">
                                <FormattedMessage
                                    id={"driver.delete-service"}
                                />
                            </Button>}
                    </Form>,
                ];
            }
            default: {
                return null;
            }
        }
    }

    private getLang(): Lan {
        return window.location.pathname.split("/")[1] as Lan;
    }

    public render(): React.ReactNode {
        return [
                <NavGoBack key={"nav-go-back"} title={<FormattedMessage id={"dash.add-cloud-storage"}/>}/>,
                <div key={"add-body"} className="add-storage-box">
                    <div style={{ position: "absolute", left: 32, top: 16 }}>
                        <span style={{ paddingRight: 12 }}>
                            <FormattedMessage id={"global.current-region"} />:
                        </span>
                        {getRegionName(region, this.getLang())}
                    </div>
                    <div className="add-storage-mid-box">
                        {this.renderStorageByProvide()}
                    </div>
                </div>,
            ];
    }
}

export default withRouter(injectIntl(AddStorageDriver));



// WEBPACK FOOTER //
// ./src/components/portal/driverComponents/AddStorageDriver.tsx